<section class="hvac-page-section hvac-public-links">
    <h3 *ngIf="data?.Content?.title" class="hvac-landing-page-heading hvac-h3" [innerHTML]="data?.Content?.title | richText"></h3>
    <p *ngIf="data?.Content?.text" class="hvac-featured-content-description" [innerHTML]="data?.Content?.text | richText"></p>
    <ul class="hvac-marketing-links">
        <li class="hvac-marketing-links-item" *ngFor="let item of data?.Content?.list.$values">
            <hvac-public-links-item [item]="item"></hvac-public-links-item>
        </li>
    </ul>
</section>
